export default "__VITE_ASSET__iI6PYPi7__"